import PortfolioDetails from "./PortfolioDetails";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Box, Typography, Container } from "@mui/material";
import { useTheme } from "../../contexts/ThemeContext";

const Portfolio = () => {
  const { fundName, strategyName } = useParams();
  const { currentTheme } = useTheme();

  return (
    <>
      <Helmet>
        <title>Portfolio | Vantage Alpha</title>
      </Helmet>

      <Box
        sx={{
          backgroundColor:
            currentTheme.palette.mode === "light"
              ? "#ebebeb"
              : currentTheme.palette.grey[50],
          background:
            currentTheme.palette.mode === "light"
              ? "#ebebeb"
              : currentTheme.palette.grey[50],
          minHeight: "100vh",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 600,
                color: currentTheme.palette.text.primary,
                mb: 1,
              }}
            >
              Portfolio
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: currentTheme.palette.text.secondary,
              }}
            >
              Monitor portfolio performance, positions, and market data
            </Typography>
          </Box>
          <PortfolioDetails fundName={fundName} strategyName={strategyName} />
        </Container>
      </Box>
    </>
  );
};
export default Portfolio;
